export default "__VITE_ASSET__DpHIlEfK__"